
export default {
  props: {
    links: Array,
    page: Number,
    loading: Boolean
  },
  methods: {
    pageClicked (page) {
      let pageNumber = page

      if (!(typeof page === 'number')) {
        if (page === this.links[0].label) {
          pageNumber = this.page - 1
        } else {
          pageNumber = this.page + 1
        }
      }
      if (this.loading) {
        return
      }
      this.$emit('page-click', pageNumber)
    },
    getLabel (label) {
      label = label.toString().toLowerCase()
      if (['previous', 'السابق'].includes(label)) {
        return this.$t('التالي')
      }
      if (['next', 'التالي'].includes(label)) {
        return this.$t('السابق')
      }
      return label
    }
  }
}
